import { render, staticRenderFns } from "./CreateItemReceiptsModal.vue?vue&type=template&id=97e7b8fa&scoped=true&"
import script from "./CreateItemReceiptsModal.vue?vue&type=script&lang=js&"
export * from "./CreateItemReceiptsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateItemReceiptsModal.vue?vue&type=style&index=0&id=97e7b8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e7b8fa",
  null
  
)

export default component.exports